import type { ActionDefinition, RuleAction, RuleActionContext } from "./types";

export class ActionRegistry {
  private readonly definitions = new Map<string, ActionDefinition>();

  register(type: string, definition: ActionDefinition): void {
    this.definitions.set(type, definition);
  }

  execute(context: RuleActionContext, action: RuleAction): void {
    const def = this.definitions.get(action.type);
    if (!def) throw new Error(`Unknown action type: ${action.type}`);
    def.execute(context, action);
  }
}
